/**
 * @ngdoc directive
 * @name cart-option
 *
 * @description
 * Cart option component
 */
module.directive('cartOption', function() {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        scope: {
            option: '=',
            type: '@?'
        },
        controller: ['$scope', '$filter', 'cart', '$timeout', function ($scope, $filter, $cart, $timeout) {
            $scope.options = [
                {text:$filter('translate')('form.yes'), value: true},
                {text:$filter('translate')('form.no'), value: false}
            ];

            $scope.$watchCollection('option', function (value) {
                if (value) {
                    $cart.update()
                }
            });
        }],
        templateUrl: 'src/components/cart-option/cart-option.html'
    };
});
